(function (angular) {
	'use strict';

	angular
		.module('viewPlanModule')
		.controller('PlanSummary', [
			'$filter',
			'globalConfig',
			'orderFormFactory',
			'planFactory',
			'ReitElementFactory',
			'urlFactory',
			PlanSummaryFunction
		]);

	function PlanSummaryFunction(
		$filter,
		globalConfig,
		orderFormFactory,
		planFactory,
		ReitElementFactory,
		urlFactory) {
		
		var planSummary = this;

		planSummary.$onInit = function() {
			angular.extend(planSummary, globalConfig);
			planFactory.getPlanData(planSummary.riaPlanTypes).then(function(response){
				angular.forEach(response.data, function(plan) {
					if(plan.planId === planSummary.riaPlanId) {
						planSummary.planData = plan;
						planSummary.planDataArr = [planSummary.planData];
					}
				});
			});

			ReitElementFactory.getReitElementListsForPlan(planSummary.riaPlanId).then(function(reitElementLists) {
				angular.extend(planSummary, reitElementLists);
			});

			planSummary.planOptions = [
				{
					label: 'Long-Term Growth',
					value: 'long-term-growth'
				},
				{
					label: 'Balanced Investing',
					value: 'balanced-investing'
				},
				{
					label: 'Supplemental Income',
					value: 'supplemental-income'
				}
			];

			planSummary.selectedPlan = $filter('filter')(planSummary.planOptions, { 'value': globalConfig.planSlug })[0];
		};

		planSummary.changePlan = function() {
			urlFactory.redirect('/start-investing/advanced-plans/' + planSummary.selectedPlan.value);
		};

		planSummary.submitOrderForm = function() {
			orderFormFactory.submitOrderForm(planSummary.riaPlanId).then(function(){
				urlFactory.redirect('/reits/signup-checkout/signup');
			});
		};
	}
})(window.angular);